import { render, staticRenderFns } from "./LanguageSettingHeaderMenu.vue?vue&type=template&id=b433c42c"
import script from "./LanguageSettingHeaderMenu.vue?vue&type=script&lang=js"
export * from "./LanguageSettingHeaderMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports